import { ERC20, NFT, Token } from 'src/common/types/models/Tokens'

export function isNFTType(token: Partial<Token>): token is NFT {
  return 'tokenId' in token && typeof token.tokenId === 'number'
}

export function isERC20Type(token: Partial<Token>): token is ERC20 {
  return 'decimals' in token && typeof token.decimals === 'number'
}
